<div *ngIf="!isLoading && !isError">
    <mat-toolbar class="bar-filler">
        <div></div>
    </mat-toolbar>
    <div>
        <form class="small-margin small-padding"> 
            <mat-form-field class="fill-parent-width">
                <mat-label>{{'Pages.ConfirmAddress.Form.LocationName' | translate }}</mat-label>
                <input type="text" autocomplete="off" matInput placeholder="{{'Pages.ConfirmAddress.Form.LocationNameEx' | translate }}" [(ngModel)]="locationname" name="locationname">
                <mat-hint align="start">{{'Pages.ConfirmAddress.Form.LocationNameHint' | translate}}</mat-hint>
            </mat-form-field>
            <div style="height: 15px;"></div>
            <mat-form-field class="fill-parent-width">
                <mat-label >{{'Pages.ConfirmAddress.Form.Line1' | translate}}</mat-label>
                <input matInput type="text" [(ngModel)]="line1" name="line1" [disabled]="true">
            </mat-form-field>
            <mat-form-field class="fill-parent-width">
                <mat-label>{{'Pages.ConfirmAddress.Form.Line2' | translate}}</mat-label>
                <input matInput type="text" autocomplete="off" placeholder="{{'Pages.ConfirmAddress.Form.Line2Ex' | translate}}" [(ngModel)]="line2" name="line2">
                <mat-hint align="start"><strong></strong>{{'Pages.ConfirmAddress.Form.Line2Hint' | translate}}</mat-hint>
            </mat-form-field>
        </form>
        <div class="small-margin small-padding">
            <button class="fill-parent-width" mat-flat-button color="accent" (click)="confirm()">{{'Pages.ConfirmAddress.ConfirmAddress' | translate}}</button>
        </div>
    </div>
    <mat-toolbar color="primary" class="top-bar">
        <button mat-icon-button (click)="back()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <div>{{'Pages.ConfirmAddress.Title' | translate}}</div>
    </mat-toolbar>
</div>
<div *ngIf="isLoading && !isError" class="floating-container">
    <mat-spinner></mat-spinner>
    <p class="floating-label">{{'Pages.ConfirmAddress.SavingMessage' | translate}}</p>
</div>
<div *ngIf="isError" class="floating-container">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{'Errors.ConectionError.Title' | translate}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>{{'Errors.ConectionError.Message' | translate}}</p>
          </mat-card-content>
          <mat-card-actions>
            <button mat-raised-button color="primary" class="fill-parent-width" (click)="tryAgain()">{{'Errors.ConectionError.Button' | translate}}</button>
          </mat-card-actions>
    </mat-card>
</div>